<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :is-loading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <bita-formgroup
            title="اطلاعات تکمیل نشده"
            class="row"
            v-if="hasInCompleteData"
          >
            <bita-input
              v-if="outPutRemittanceNumberIsInComplete"
              type="text"
              name="output_remittance_number"
              label="شماره حواله"
              :rules="''"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.output_remittance_number"
            />
            <bita-select
              v-if="loadIsInComplete"
              name="categoryLoads"
              label="دسته بندی نوع بار"
              ref="categoryLoadsDropDown"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="categoryLoads"
              data-text-field="name"
              data-value-field="id"
              v-model="dataForm.category_loads_id"
              @change="(e) => this.getLoads(e)"
            />

            <bita-spinner
              :is-loading="isLoadingLoads"
              :class-name="colWidth"
              styleName="align-self: center;"
            />

            <bita-select
              v-if="this.isLoadingLoads === false && loadIsInComplete"
              name="loads"
              label="نوع بار"
              ref="loadsDropDown"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="loads"
              data-text-field="name"
              data-value-field="id"
              v-model="dataForm.load_id"
            />
            <bita-select
              v-if="customerIsInComplete"
              name="loads"
              label="مشتری"
              ref="loadsDropDown"
              rules=""
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="customers"
              data-text-field="full_name"
              data-value-field="id"
              v-model="dataForm.customer_id"
            />
          </bita-formgroup>
          <div v-else class="alert alert-success">
            اطلاعات تکمیل است
          </div>
          <bita-formgroup title="اطلاعات راننده" class="row">
            <label-value label="نام" :value="propsData.driver_name+' '+propsData.driver_family" />
            <label-value label="شماره تماس" :value="propsData.driver_phone" />
            <label-value label="کد ملی" :value="propsData.driver_national_code" />
          </bita-formgroup>

          <bita-formgroup title="اطلاعات مشتری" class="row">
            <label-value label="نام" :value="propsData.customer_name" />
            <label-value label="نام خانوادگی" :value="propsData.customer_family" />
            <label-value label="کد ملی" :value="propsData.customer_national_code" />
            <label-value label="شماره تماس" :value="propsData.customer_phone"/>
            <label-value label="شهر" :value="propsData.customer_city" />
            <label-value label="استان" :value="propsData.customer_province" />
            <label-value label="آدرس" :value="propsData.customer_address" />
          </bita-formgroup>
          <bita-formgroup title="اطلاعات صاحب بار" class="row">
            <label-value label="نام" :value="propsData.owner_name" />
            <label-value label="کد ملی" :value="propsData.owner_national_code" />
            <label-value label="شماره تماس" :value="propsData.owner_phone"/>
            <label-value label="کد پستی" :value="propsData.owner_postal_code" />
            <label-value label="شهر" :value="propsData.owner_city" />
            <label-value label="استان" :value="propsData.owner_province" />
            <label-value label="آدرس" :value="propsData.owner_address" />
          </bita-formgroup>
          <bita-formgroup title="اطلاعات بار" class="row">
            <label-value label="نوع بار" :value="propsData.load_name" />
            <label-value
              :label="$currencyLabel('قیمت')"
              :value="$thousandSeprator(propsData.price)"
            />
            <label-value
              :label="$currencyLabel('قیمت صافی')"
              :value="$thousandSeprator(propsData.net_price)"
            />
            <label-value
              label="هزینه بارگیری پرداخت شده"
              :value="propsData.loading_fee"
            />
            <label-value
              label="شماره حواله"
              :value="propsData.output_remittance_number"
            />
          </bita-formgroup>
        </div>
      </bita-form>
    </div>
    <div slot="footer">

<!--      <input type="checkbox" id="checkbox" v-model="dataForm.send_sms_to_customer">-->
      <label> {{ sendMessageToCustomer() }} </label>
      <label class="ml-3 mr-3 switch">
        <input type="checkbox" v-model="dataForm.send_sms_to_customer"/>
        <span class="slider round"></span>
      </label>
      <bita-bootbutton
        v-if="$acl.isOwner"
        type="primary"
        title="ترخیص"
        icon="fas fa-external-link-square-alt"
        btn-width="150px"
        @click.native="handleSubmit()"
      />
      <bita-bootbutton
        class="mr-2"
        type="danger"
        title="بستن"
        icon="fas fa-times"
        btn-width="150px"
        data-dismiss="modal"
        @click.native="onCloseModal()"
      />
    </div>
  </bita-modal>
</template>
<script>
import LabelValue from "./LabelValue";
var request = {};
export default {
  components: { LabelValue },
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    onSubmit: {},
    categoryLoads: {},
    customers: {},
    propsData: {
      type: Object,
    },
  },
  data() {
    return {
      colWidth: "col-lg-3 col-md-6 col-sm-6",
      formData: {},
      dataForm: {},
      loads: [],
      isLoadingLoads: false,
    };
  },
  computed: {
    customerIsInComplete() {
      return !this.propsData.customer_id;
    },
    loadIsInComplete() {
      return !this.propsData.load_id;
    },
    outPutRemittanceNumberIsInComplete() {
      return !this.propsData.output_remittance_number;
    },
    hasInCompleteData() {
      return (
        this.customerIsInComplete ||
        this.loadIsInComplete ||
        this.outPutRemittanceNumberIsInComplete
      );
    },
  },
  watch: {
    // propsData: function(__data) {
    //   this.dataForm = __data;
    // },
  },
  methods: {
    sendMessageToCustomer(){
      return this.dataForm.send_sms_to_customer ? 'ارسال پیامک به مشتری' : 'عدم ارسال پیامک به مشتری' ;
    },
    getLoads(categoryId) {
      this.isLoadingLoads = true;

      this.$persistClient("get", `loads?filter[parentItem]=${categoryId}`)
        .then((res) => {
          this.loads = res.data;
        })
        .finally(() => {
          this.isLoadingLoads = false;
        });
    },
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$alert(
            "question",
            `ایا از اطلاعات و ترخیص این بار مطمئن هستید ؟؟`,
            "",
            {
              confirmButtonText: "تایید",
            }
          ).then((result) => {
            this.dataForm.id = this.propsData.id;
            this.dataForm.alertCheck = result.isConfirmed;
            this.$emit("on-submit", this.dataForm);
          })
        }
      });
    },
    reset() {
      this.$refs.loadsDropDown ? this.$refs.loadsDropDown.emptyKendo() : null;
      this.$refs.categoryLoadsDropDown ? this.$refs.categoryLoadsDropDown.emptyKendo() : null;
      this.$refs.loadsDropDown ? this.$refs.loadsDropDown.emptyKendo() : null;
      this.$refs.form.reset();
      this.dataForm = {};
    },
    onCloseModal(e) {
      this.reset();
    },
  },
};
</script>
<style scoped>
  .switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 25px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 2px;
    bottom: 3px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
  }

  input:checked + .slider {
    background-color: #2196F3;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 25px;
  }

  .slider.round:before {
    border-radius: 50%;
  }

</style>